import React from 'react'
import Lang from "@components/Lang/Lang"
// import ExportBtn from '../component/ExportBtn'
import CommonBreadcrumb from "@components/CommonBreadcrumb";
import {symbolMoneyUtil,} from '@utils/utils';
import ExportBtn from '@/components/ExportBtn/index'
import ExportData from '../component/ExportData'
import {Input, Select, Space, Table, Button, Modal, message, Form, Spin,} from 'antd'
import dayjs from "dayjs";
import RefundRegistrationModal from "../component/RefundRegistrationModal​";
import './RefundStatistics.less'
import {postRefundList, postRefundDispose} from "@/api/financeManagement";
import {Link} from "react-router-dom";

const { Search } = Input
const { Option } = Select
const { Column, ColumnGroup } = Table
class RefundStatistics extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            showDealWithModal: false,
            showExportModal: false,
            loading: true,
            filter: {
                buyer: '',
                orderid: '',
                status: 0,
            },
            list: [],
            pagination: {
                pageSize: 50,
                total: 0,
                pageNum: 1
            },
            rowData: {},
        }
        this.filterForm = React.createRef()
    }

    /** input 中的搜索*/
    onSearch(value) {
        // console.log(233, this);
        let filter = this.filterForm.current.getFieldsValue()
        Object.keys(filter).forEach(key => {
            if (key === 'status') { // status为number
                filter[key] = filter[key]
            } else {
                filter[key] = filter[key] ? filter[key].trim() : null
            }
        })
        this.setState({
            filter,
            pagination: {
                ...this.state.pagination,
                pageNum: 1,
            },
        }, () => {
            // console.log(this.state);
            this.getList()
        })
    }

    // 重置过滤条件
    resetFields() {
        this.filterForm.current.resetFields()
        let filter = this.filterForm.current.getFieldsValue()
        this.setState({
            filter,
        }, () => {
            // console.log(this.state);
            this.getList()
        })
    }

    dealWithModalOK() {
        postRefundDispose({
            id: this.state.rowData.id,
            serviceTypeCode: this.state.rowData.serviceTypeCode
        }).then(res => {
            message.success('操作成功')
            this.setState({
                showDealWithModal: false,
            }, () => { this.getList() })
        })
    }

    dealWithModalCancel() {
        this.setState({
            showDealWithModal: false
        })

    }

    getList() {
        this.setState({
            loading: true
        }, () => {
            postRefundList({
                ...this.state.filter,
                pagingQuery: {
                    pageIndex: this.state.pagination.pageNum,
                    pageSize: this.state.pagination.pageSize,
                },
            }).then(res => {
                // console.log(res.data);
                if(res.data&&res.data.models){
                    res.data.models.forEach((item, index) => {
                        item.key = index.toString()
                    })
                }
                this.setState({
                    list: res.data.models || [],
                    pagination: res.data.paging || {},
                    loading: false,
                })
            })
        })
    }

    onChange(pagination, filters, sorter, extra){
        this.setState({
            pagination: {
                ...this.state.pagination,
                pageNum: pagination.current,
                pageSize: pagination.pageSize,
            },
        }, () => {this.getList()})
    }
    refreshPage(){
        this.getList()
    }
    componentDidMount() {
        this.getList()
    }

    render() {
        return (
            <div className="refund-statistics customer-screen">
                <CommonBreadcrumb
                    list={[{ name:Lang({id: 'TuiKuanChuLi', default: '退款处理'}) }]}
                ></CommonBreadcrumb>
                <div data-flex="cross:top main:justify" className="mb_16">
                    <div className="filter-box">
                        <Form className="input-form"
                              ref={this.filterForm}
                              layout="inline">
                            <Form.Item
                                name="status">
                                <Select
                                    className=""
                                    placeholder={Lang({id:'QingXuanZeTuiKuanZhuangTai', default: '请选择退款状态'})}
                                    style={{ width: 140 }}>
                                    <Option value={0}>{Lang({id: 'QuanBu', default: '全部'})}</Option>
                                    <Option value={1}>{Lang({id:'DaiTuiKuan', default:'待退款'})}</Option>
                                    <Option value={2}>{Lang({id:'YiTuiKuan', default:'已退款'})}</Option>
                                </Select>
                            </Form.Item>

                            <Form.Item
                                name="orderid">
                                <Input placeholder={Lang({id: 'QingShuRuDingDanHao', default: '请输入订单号'})}
                                       className=""
                                       style={{ width: 204 }} />
                            </Form.Item>

                            <Form.Item
                                name="buyer">
                                <Search placeholder={Lang({id: 'QingShuRuCaiGouShangBianMaHuoMingCheng', default: '请输入采购商编码或名称'})}
                                        onSearch={(value) => this.onSearch(value)}
                                        className=''
                                        style={{ width: 288 }} />
                            </Form.Item>

                            <Form.Item>
                                <Button type="text" onClick={this.resetFields.bind(this)}>
                                    {Lang({id: 'ZhongZhi', default: '重置'})}
                                </Button>
                            </Form.Item>
                        </Form>

                    </div>

                    <ExportBtn onClick={() => {this.setState({showExportModal: true})}} authName="RefundStatics-Export-Button"></ExportBtn>
                </div>

                <Spin spinning={this.state.loading}>
                    {/*表格*/}
                    <Table pagination={{defaultPageSize: this.state.pagination.pageSize, showQuickJumper: true, total: this.state.pagination.total, current: this.state.pagination.pageNum || 1, showSizeChanger: true, showTotal: (total) => `Total ${total} items`,}}
                        /*rowKey={(record, index) => index.toString()}*/
                           onChange={this.onChange.bind(this)}
                           dataSource={this.state.list}
                           className="refund-table-vertical-center"
                           rowClassName={(record) => record.disposeStatus==="handled"? 'completed-row':''}>
                        <Column title={Lang({id: 'PODanHao', default: 'PO单号'})} dataIndex="poCode" key="poCode" />
                        <Column title={Lang({id: 'CaiGouShang', default: '采购商'})} dataIndex="buyerCode" key="buyerCode"
                                render={(text, record, index) => {
                                    return (
                                        <Space direction="vertical ">
                                            <Link className="link" to={
                                                {
                                                    pathname: '/customer/detail',
                                                    search: `?id=${record.buyerId}`,
                                                    state: {id: record.buyerId},
                                                }
                                            }>
                                                <div className={"font-main2 fw_500"}>{record.buyerCode}</div>
                                            </Link>

                                            {/*<div className="subhead text-overflow" style={{width: '82px',}}>{record.buyerName}</div>*/}
                                        </Space>
                                    )
                                }}/>
                        <Column title={Lang({id: 'ChuLiShiJian', default: '处理时间'})}
                                width={120}
                                dataIndex="disposeTime"
                                key="disposeTime"
                                render={(text, record, index) => (
                                    <p className={"fw_500"}>{record.disposeTime?dayjs(record.disposeTime).format("YYYY-MM-DD"):'-'}</p>
                                )}/>
                        <Column title={Lang({id: 'FuWuLeiXing', default: '服务类型'})}
                                dataIndex="serviceType"
                                width={150}
                                key="serviceType"
                                render={(text, record, index) => (
                                    <div className={`${record.serviceTypeCode=='title_to_goods'?'labelSpanOra':'fw_500'}`}>{record.serviceType}</div>
                                )}/>
                        <Column title={Lang({id: 'TuiKuanLeiXing', default: '退款类型'})}
                                dataIndex="type"
                                key="type"
                                width={150}
                                render={(text, record, index) => (
                                    <div className={"fw_500"}>
                                    {/*{record.status==='refund'&&<span>{Lang({id: 'YiTuiKuan', default: '已退款'})}</span>}*/}
                                    {/*{record.status==='not_refund'&&<span className={"color-green"}>{Lang({id: 'XuTuiKuan', default: '需退款'})}</span>}*/}
                                    {/*{record.status==='not_need_refund'&&<span className={"font-main"}>{Lang({id: 'BuTuiKuan', default: '不退款'})}</span>}*/}
                                        {/* isNeedRefund 是否需要退款  0不需要  1需要  */}
                                        {record.isNeedRefund==1&&<div>
                                            {/*{record.status==='refund'?<span>{Lang({id: 'YiTuiKuan', default: '已退款'})}*/}
                                        {/*</span>:<span className={"color-green"}>{Lang({id: 'XuTuiKuan', default: '需退款'})}</span>}*/}
                                            <span className={"color-green"}>{Lang({id: 'XuTuiKuan', default: '需退款'})}</span>
                                        </div>}
                                        {record.isNeedRefund!=1&&<span className={"font-main"}>{Lang({id: 'BuTuiKuan', default: '不退款'})}</span>}
                                    </div>
                                )}/>
                        <Column title={Lang({id: 'TuiKuanJinE', default: '退款金额'})}
                                dataIndex="refundAmount"
                                width={150}
                                key="refundAmount"
                                render={(text, record, index) => (
                                    <p className={"fw_500"}>
                                        {/*{record.currencySymbol} {parseFloat(record.refundAmount||0).toFixed(2)}*/}
                                        {symbolMoneyUtil(record.refundAmount, record.currencySymbol)}
                                    </p>
                                )}/>
                        {/*<Column title={Lang({id: 'TuiKuanZhuangTai', default: '退款状态'})}*/}
                                {/*dataIndex="status"*/}
                                {/*key="status"*/}
                                {/*render={(text, record, index) => (*/}
                                    {/*<p>*/}
                                        {/*{record.status==='refund'&&Lang({id: 'YiTuiKuan', default: '已退款'})}*/}
                                        {/*{record.status==='not_refund'&&Lang({id: 'DaiTuiKuan', default: '待退款'})}*/}
                                    {/*</p>*/}
                                {/*)}/>*/}
                        <Column title={Lang({id: 'ShangPinBianMa', default: '商品编码'})} dataIndex="productCode" key="productCode"
                                width={150}
                                render={(productCode, record, index) => (
                            <div className={"fw_500 word-break-all"}>
                                {/*{record.currencySymbol} {parseFloat(record.refundAmount||0).toFixed(2)}*/}
                                {record.productCode||"-"}
                            </div>
                        )}/>
                        <Column title={Lang({id: 'ShouKuanXinXi', default: '收款信息'})}
                                dataIndex="info"
                                key="info" // todo
                                render={(text, record, index) => (
                                    record.status==='not_need_refund'||(!record.bankName&&!record.bankNo)?<div>--</div>:<div>
                                        <div>{Lang({id: 'YinXing', default: '银行'})}：{record.bankName||"-"}</div>
                                        <div>{Lang({id: 'GongSi', default: '公司'})}：{record.companyName||"-"}</div>
                                        <div>{Lang({id: 'KaHao', default: '卡号'})}：{record.bankNo||"-"}</div>
                                    </div>
                                )}/>
                        <Column title={Lang({id: 'ZhuangTai', default: '状态'})} dataIndex="disposeStatus" key="disposeStatus"
                                render={(text, record, index) => (
                                    <div>
                                        {/* isNeedRefund 是否需要退款  0不需要  1需要 record.disposeStatus==='to_de_handle" */}
                                        {record.disposeStatus==='to_de_handle'?<RefundRegistrationModal row={record} refreshPage={()=>this.refreshPage()}>
                                                <Button className="handleBtn">{Lang({id: 'TuiKuanDengJi2', default: '退款登记'})}</Button>
                                            </RefundRegistrationModal>:<RefundRegistrationModal row={record} readOnly={true} paymentSlipFileUrl={record.paymentSlipFileUrl}>
                                                <Button className="completeBtn">{Lang({id: 'DengJiWanCheng', default: '登记完成'})}</Button>
                                            </RefundRegistrationModal>}

                                        {/*{record.disposeStatus==='to_de_handle'&&(  <button className="my-btn" onClick={()=>{this.setState({showDealWithModal: true, rowData: record})}}>*/}
                                            {/*{Lang({id: 'QuChuLi', default: '去处理'})}*/}
                                        {/*</button>)}*/}
                                        {/*{record.disposeStatus==="handled"&&(<button className="my-btn disabled">*/}

                                        {/*</button>)}*/}

                                    </div>
                                )}/>
                    </Table>
                </Spin>

                <Modal title={Lang({id: 'TiShi', default: '提示'})}
                       className="refund-statistics-dealWithModal"
                       open={this.state.showDealWithModal}
                       onOk={this.dealWithModalOK.bind(this)}
                       onCancel={this.dealWithModalCancel.bind(this)}
                       cancelText={Lang({id: 'ShaoHouZaiChuLi', default: '稍后再处理'})}
                       cancelButtonProps={{shape:'round'}}
                       okButtonProps={{type:'primary', shape:'round'}}
                       okText={Lang({id: 'YiWanCheng', default: 'YiWanCheng'})}>
                    <p>{Lang({id: 'QingQueRenGaiBiTuiKuanXianXiaYiWanChengDengJi', default: '请确认该笔退款线下已完成登记？'})}</p>
                </Modal>

                <ExportData isModalVisible={this.state.showExportModal} showSwich={(isShow) => {this.setState({showExportModal: isShow})}}></ExportData>
            </div>
        )
    }
}

export default RefundStatistics
